import { render } from "./RiepilogueSecondaryTitle.vue?vue&type=template&id=4fa6d7bf"
const script = {}
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "4fa6d7bf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4fa6d7bf', script)) {
    api.reload('4fa6d7bf', script)
  }
  
  module.hot.accept("./RiepilogueSecondaryTitle.vue?vue&type=template&id=4fa6d7bf", () => {
    api.rerender('4fa6d7bf', render)
  })

}

script.__file = "src/views/services/pageTitles/RiepilogueSecondaryTitle.vue"

export default script